import React, { useCallback } from 'react';

import * as S from './styles';

type Tab = {
  active: boolean;
  id: string;
  image?: React.ReactElement;
  title: React.ReactNode;
  to: string;
};

type TabProps = Tab & {
  onClick?: (tab: string) => void;
};

type OwnProps = {
  className?: string;
  onClick?: (tab: string) => void;
  tabs: Tab[];
};

const TabItem = ({ active, id, image, onClick, title, to }: TabProps) => {
  const handleOnClick = useCallback(() => {
    if (!onClick) return null;
    return onClick(id);
  }, [id, onClick]);

  return (
    <S.TabLink active={active} onClick={handleOnClick} to={to}>
      {image && <S.Image>{image}</S.Image>}
      {title}
    </S.TabLink>
  );
};

const Tabs = ({ className, onClick, tabs }: OwnProps) => {
  return (
    <S.Tabs className={className}>
      {tabs.map(tab => (
        <TabItem {...tab} key={tab.id} onClick={onClick} />
      ))}
    </S.Tabs>
  );
};

export default Tabs;
